import Input from '../components/Input'
import { connect } from 'react-redux'
import { setContents, setInputKeys, setShowUploadModal, setSelectedContext,
  setContext, setContextsFromVocabularies, setVocabularyType, setContextsFromGist } from '../util/actions'
import { initInputKeys, getContextKeys, getGistList, getContextVocabularies } from '../util/utils'

const mapStateToProps = (state) => ({
  user: state.user,
  contents: state.mapping.contents,
  publishedContexts: state.context.publishedContexts,
  inputKeys: state.mapping.inputKeys,
  vocabularies: state.mapping.vocabularies,
  contextsFromVocabularies: state.mapping.contextsFromVocabularies,
  vocabularyType: state.mapping.vocabularyType,
  selectedContext: state.mapping.selectedContext,
  rawJsonld: {
    '@id': '',
    '@type': state.mapping.vocabularyType ? state.mapping.vocabularyType : '',
  }
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setInputKeys: (targetJson, inputKeys) => {
    let newKeys = initInputKeys(targetJson, inputKeys)
    dispatch(setInputKeys(newKeys))
    Object.keys(newKeys).forEach(key => {
      dispatch(setVocabularyType(key, ''))
    })
  },
  setContents: (parsedInput) => {
    dispatch(setContents(parsedInput))
  },
  handleClickUpload: (showUploadModal, isMapping) => {
    dispatch(setShowUploadModal(showUploadModal, isMapping))
  },
  initContextList: async (props) => {
    const newContexts = await getContextVocabularies(props)
    dispatch(setContextsFromVocabularies(newContexts))

    if(props.user.uid){
      const List = await getGistList(props.user)
      dispatch(setContextsFromGist(List))
    }
  },
  setSelectedVocabulary: (inputKeys, vocabulary) => {
    dispatch(setSelectedContext(vocabulary))
    const keys = getContextKeys(inputKeys, vocabulary)
    dispatch(setContext(keys))
  },
  handleSelectDemo: (file) => {
    const filename = './demo/' + file.file
    return fetch(filename).then(res => {
      if (res.ok) {
        return res.json()
      }
      throw new Error('Network response was not ok.')
    }).then(json => {
      dispatch(setContents(json))
    }).catch(error => console.error('Error:', error))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Input)



// WEBPACK FOOTER //
// ./src/containers/Input.js